export const CONTENT_MAX_WIDTH = 768;
export const NARROW_MAX_WIDTH = 480;

// Desktop shell (web >1024px only — see useDesktopShell)
export const SIDEBAR_WIDTH = 240;
// The map screen's collapsed sidebar (Sept 2026 — the map is the main
// workspace there, drawing tools included, so the full 240px sidebar costs
// too much of it). Icons only, centered; see SidebarNav's `variant` prop and
// AppShell. Every other desktop screen keeps SIDEBAR_WIDTH.
export const SIDEBAR_RAIL_WIDTH = 64;
// Signed-in sidebar footer fixed height; UserMenuDropdown anchors its
// bottom edge to this so the menu opens flush above the identity row.
export const SIDEBAR_FOOTER_HEIGHT = 64;
export const DETAIL_PANEL_WIDTH = 420;
// The observation presentation docks wider than the structure panel: the
// photo is the point, and at DETAIL_PANEL_WIDTH a portrait shot is a strip.
export const PRESENTATION_PANEL_WIDTH = 640;
// The defense plan editor docks narrower than the structure panel: its
// content is a 2x4 palette and a short list, not a photo or a checklist.
export const PLAN_PANEL_WIDTH = 360;
export const DESKTOP_CONTENT_MAX_WIDTH = 1120;
// A text-only News post on desktop reads in this column instead of the
// full content width: ~70 characters a line at the reading size (Sept 28).
export const READING_MAX_WIDTH = 680;
// DockedPanel's slide-in duration (Easing.out(Easing.cubic)). Shared with
// webStyles.TRANSITION_DOCK_INSET so the floating map chrome that shifts to
// clear a panel (search bar, MapControls) moves at the same speed the panel
// slides in at, instead of jump-cutting to its new position.
export const DOCK_PANEL_TRANSITION_MS = 220;

/**
 * Height of the shell's top header band, above its rule. The sidebar and the
 * content pane both end their header at this y, so their two grey lines read
 * as one rule running across the shell.
 *
 * Three places draw that rule and every one of them must use this token:
 * `SidebarNav.headerRow` + `headerDivider`, `layout/Header.tsx` (desktop
 * branch), and the feed screen's own animated header. They used to share only
 * a 24px top inset and let their content decide where the line fell, which
 * put it at 72 / 78 / 91 on the same screen.
 *
 * 80 centers the sidebar's 32px create button exactly (24 above, 24 below)
 * and leaves the content header 10px under its title.
 *
 * A content header is SHELL_HEADER_HEIGHT + SHELL_RULE_WIDTH tall, because
 * its rule is a bottom border painted inside the box; the sidebar's is a
 * separate 1px element that sits after an 80px row. Both land on the same
 * two rows of pixels.
 */
export const SHELL_HEADER_HEIGHT = 80;
/**
 * Weight of that rule. Deliberately not StyleSheet.hairlineWidth: on a 2x
 * display hairlineWidth is 0.5px, so a hairline content header next to the
 * sidebar's 1px divider read as two different greys even once they lined up.
 */
export const SHELL_RULE_WIDTH = 1;

// Panel budget on the desktop map (docs/plans/panel-system.md). The map
// keeps at least MIN_MAP_WIDTH between the docks; when a new panel would
// squeeze it below that, resolvePanelLayout (utils/panelLayout.ts) collapses
// the far dock to a DOCK_TAB_WIDTH tab and folds the companion into its
// parent. COMPANION_PANEL_WIDTH is the task panel that slides out beside a
// left dock (Assign, edit party, plan updates).
export const MIN_MAP_WIDTH = 400;
export const COMPANION_PANEL_WIDTH = 380;
// Height of the plan editor's pinned header, rule included (overline, title
// row, then the meta line with the Shared pill). Companion panels use it as
// their header's minimum, so the two header rules sit on one line (Oct 1
// 2026: the Assign rule sat 2px above the plan's).
export const PLAN_PANEL_HEADER_HEIGHT = 91;
export const DOCK_TAB_WIDTH = 40;
